import React from 'react';

import Image from 'components/common/Image';
import LoadingDots from 'components/common/LoadingDots';

import loadingQrCodeSrc from 'assets/images/qrCode/loadingQrCode.png';

import styles from './QrCode.module.scss';

interface QrCodeProps {
  url?: string | null;
}

const QrCode = ({ url = null }: QrCodeProps) => {
  return (
    <>
      {url && (
        <Image
          className={styles.qrCode}
          src={url}
          alt="QR Code"
          data-testid="qr-code"
        />
      )}
      {!url && (
        <div className="position-relative">
          <Image
            className={styles.qrCode}
            src={loadingQrCodeSrc}
            alt="QR Code Loading"
            data-testid="qr-code-loading"
          />
          <div className={styles.loadingDots}>
            <LoadingDots />
          </div>
        </div>
      )}
    </>
  );
};

export default QrCode;
